export default __webpack_public_path__ + "static/media/texts-square.94080e68.jpg";